import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { slugify } from '../../helpers';

const SelectGroupHeading = (props) => {
  const { children } = props;
  const {
    results,
    type,
    handleLabelClick,
    ...nprops
  } = props;

  const intl = useIntl();

  const getLinkText = () => {
    if (results > 0) {
      if (type === 'file') {
        return intl.formatMessage({
          defaultMessage: '{results} {results, plural, one {file} other {files} } in the archive',
        }, { results });
      }

      if (type === 'collection') {
        return intl.formatMessage({
          defaultMessage: '{results} {results, plural, one {collection} other {collections} } in the archive',
        }, { results });
      }
    }
    return intl.formatMessage({
      defaultMessage: '{results} see all {children}',
    }, { results, children: children.toLowerCase() });
  };

  return (
    <div className="search-input-group-heading">
      <components.GroupHeading {...nprops} />
      <Link to={`#${slugify(children.toLowerCase())}`} onClick={handleLabelClick}>
        {getLinkText()}
      </Link>
    </div>
  );
};

SelectGroupHeading.propTypes = {
  children: PropTypes.string.isRequired,
  results: PropTypes.number,
  type: PropTypes.string,
  handleLabelClick: PropTypes.func.isRequired,
};

SelectGroupHeading.defaultProps = {
  results: 0,
  type: '',
};

export default SelectGroupHeading;
